export default __webpack_public_path__ + "static/media/trylleby-property-01.33ffbb71.jpg";